export const useRestoreBarLayout = () => {
  let container = null;
  let restoreBar = null;
  let restoreBarObserver = null;
  let resizeHandler = null;

  const setRestoreBarHeight = () => {
    if (!container) {
      return;
    }

    if (!restoreBar) {
      container.style.setProperty('--dashboard-restore-bar-height', '0px');
      // .navbarのドロップダウンメニュー等、.main-containerの外側(祖先が異なるDOM)からも
      // 実測高さを参照できるよう、documentElementにも同じCSS変数を反映して継承させる
      document.documentElement.style.setProperty('--dashboard-restore-bar-height', '0px');
      return;
    }

    const height = Math.max(0, Math.ceil(restoreBar.getBoundingClientRect().height));
    container.style.setProperty('--dashboard-restore-bar-height', `${height}px`);
    document.documentElement.style.setProperty('--dashboard-restore-bar-height', `${height}px`);
  };

  const initRestoreBarLayout = () => {
    teardownRestoreBarLayout();

    container = document.querySelector('.main-container');
    if (!container) {
      return;
    }

    restoreBar = container.querySelector('.restore-bar');
    setRestoreBarHeight();

    if (!restoreBar) {
      return;
    }

    if (typeof window.ResizeObserver === 'function') {
      restoreBarObserver = new window.ResizeObserver(() => {
        setRestoreBarHeight();
      });
      restoreBarObserver.observe(restoreBar);
      return;
    }

    resizeHandler = () => {
      setRestoreBarHeight();
    };
    window.addEventListener('resize', resizeHandler);
  };

  const teardownRestoreBarLayout = () => {
    if (restoreBarObserver) {
      restoreBarObserver.disconnect();
      restoreBarObserver = null;
    }

    if (resizeHandler) {
      window.removeEventListener('resize', resizeHandler);
      resizeHandler = null;
    }

    if (container) {
      container.style.removeProperty('--dashboard-restore-bar-height');
    }
    document.documentElement.style.removeProperty('--dashboard-restore-bar-height');

    container = null;
    restoreBar = null;
  };

  return {
    initRestoreBarLayout,
    teardownRestoreBarLayout,
    // スクロール位置計算前などに、ResizeObserverの非同期反映を待たず高さを即時反映するための公開関数
    syncRestoreBarHeight: setRestoreBarHeight,
  };
};
